
<template>
  <el-dialog :title="title" :visible.sync="showdialog" width="40%" class="dialog_dialog" :show-close='false' :close-on-click-modal="false">
    <el-form :model="form" :rules="rules" :label-width="formLabelWidth">
      <el-form-item label="审核状态："  prop="status">
        <el-select v-model="form.status" filterable placeholder="请选择状态" @change="changeStatus">
          <el-option :label="item.name" :value="item.id" v-for="(item,index) in options" :key="index" ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分数："  prop="check_score" v-if="nowVal === 2 && final != 'final'">
        <el-input v-model="form.check_score" placeholder="请输入分数"></el-input>
      </el-form-item>
      <el-form-item label="原因："  prop="check_reson" v-if="nowVal === 1 ">
        <el-input
          type="textarea"
          :rows="4"
          placeholder="请输入不合格原因"
          v-model="form.check_reson">
        </el-input>
      </el-form-item>
      <el-form-item label="审核评语："  prop="status" v-if="nowVal === 2">
        <el-input
          type="textarea"
          :rows="4"
          placeholder="请输入审核评语"
          v-model="form.check_comment">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="concel">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
// @ is an alias to /src
export default {
  name: 'dialog',
  components: {
  },
  data(){
    return {
      formLabelWidth: '120px',
      form:{
        status:'',
        check_reson:'',
        check_score:0,
        check_comment:''
      },
      options:[
        {name:'审核不合格',id:1},
        {name:'审核合格',id:2},
      ],
      rules:{
        status:{ required: true, message: '请选择状态', trigger: 'change' },
        check_reson:{ required: true, message: '请输入原因', trigger: 'change' },
        check_score:{ required: true, message: '请输入分数', trigger: 'blur' },
        check_comment:{ required: true, message: '请输入评语', trigger: 'blur' },
      },
      nowVal:0
    }
  },
  props:{
    type:{
      type:Number
    },
    title:{
      type:String
    },
    final:{
      type:String
    },
    showdialog:{
      type:Boolean
    },
  },
  created(){
    
    
  },
  mounted(){
  },
  methods:{
    changeStatus(val){
      this.nowVal = val
    },
    confirm(){
      this.$emit('dialogConfirm',this.form)
    },
    concel(){
      this.$emit('dialogConcel',this.showdialog)
    },
  },
    
}
</script>
<style lang="scss" scoped>
  .dialog_dialog .el-select,  .dialog_dialog .el-textarea,  .dialog_dialog .el-input{
    width:95%;
  }
</style>